import type { RawTilesetEntry } from "../tilesetConfigEntry";

export const projectileEntries: RawTilesetEntry[] = [
	{
		key: "ArtilleryBomb",
		sprite: "CannonBullet.png",
	},
	{
		key: "DevGunAutoKillBotProjectile",
		sprite: "WhiteProjectile.png",
	},
	{
		key: "BlackHoleProjectile",
		animations: [
			{
				loop: true,
				tags: { small: true },
				frames: [{ filename: "BlackHole-1x1.png", interval: 0 }],
			},
			{
				loop: true,
				tags: { big: true },
				width: 3,
				height: 3,
				offsetX: -1,
				offsetY: -1,
				frames: [{ filename: "BlackHole-3x3.png", interval: 0 }],
			},
		],
	},
	{
		key: "PlasmaBall",
		animations: [
			{
				loop: true,
				frames: [
					{ filename: "Shock_Projectile_2.png", interval: 100 },
					{ filename: "Shock_Projectile_1.png", interval: 100 },
					{ filename: "Shock_Projectile_0.png", interval: 100 },
				],
			},
		],
	},
	{
		key: "CryoShot",
		allowTransform: true,
		animations: [
			{
				loop: true,
				pointsTo: ["E"],
				frames: [
					{ filename: "IceProjectile_E_0.png", interval: 100 },
					{ filename: "IceProjectile_E_1.png", interval: 100 },
				],
			},
			{
				loop: true,
				pointsTo: ["NE"],
				frames: [
					{ filename: "IceProjectile_NE_0.png", interval: 100 },
					{ filename: "IceProjectile_NE_1.png", interval: 100 },
				],
			},
		],
	},
	{
		key: "SolidifierShot",
		allowTransform: true,
		animations: [
			{
				loop: true,
				pointsTo: ["E"],
				frames: [
					{ filename: "GreenProjectile_E_0.png", interval: 100 },
					{ filename: "GreenProjectile_E_1.png", interval: 100 },
				],
			},
			{
				loop: true,
				pointsTo: ["NE"],
				frames: [
					{ filename: "GreenProjectile_NE_0.png", interval: 100 },
					{ filename: "GreenProjectile_NE_1.png", interval: 100 },
				],
			},
		],
	},
	{
		key: "ShortSolidifierShot",
		allowTransform: true,
		animations: [
			{
				loop: true,
				pointsTo: ["E"],
				frames: [
					{ filename: "GreenProjectile_E_0.png", interval: 100 },
					{ filename: "GreenProjectile_E_1.png", interval: 100 },
				],
			},
			{
				loop: true,
				pointsTo: ["NE"],
				frames: [
					{ filename: "GreenProjectile_NE_0.png", interval: 100 },
					{ filename: "GreenProjectile_NE_1.png", interval: 100 },
				],
			},
		],
	},
	{
		key: "CannonBullet",
		allowTransform: true,
		animations: [
			{
				loop: true,
				pointsTo: ["E"],
				frames: [{ filename: "Bullet_E.png", interval: 0 }],
			},
			{
				loop: true,
				pointsTo: ["NE"],
				frames: [{ filename: "Bullet_NE.png", interval: 0 }],
			},
		],
	},
	{
		key: "Shrapnel",
		animations: [
			{
				loop: true,
				frames: [
					{ filename: "Shrapnel.png", interval: 30, rotation: 0 },
					{ filename: "Shrapnel.png", interval: 30, rotation: 1 },
					{ filename: "Shrapnel.png", interval: 30, rotation: 2 },
					{ filename: "Shrapnel.png", interval: 30, rotation: 3 },
				],
			},
			{
				loop: true,
				frames: [
					{ filename: "Shrapnel.png", interval: 30, rotation: 3 },
					{ filename: "Shrapnel.png", interval: 30, rotation: 2 },
					{ filename: "Shrapnel.png", interval: 30, rotation: 1 },
					{ filename: "Shrapnel.png", interval: 30, rotation: 0 },
				],
			},
		],
	},
	{
		key: "DrillBullet",
		allowTransform: true,
		animations: [
			{
				loop: true,
				pointsTo: ["E"],
				frames: [
					{ filename: "DrillProjectile_0.png", interval: 20 },
					{ filename: "DrillProjectile_1.png", interval: 20 },
					{ filename: "DrillProjectile_2.png", interval: 20 },
					{ filename: "DrillProjectile_3.png", interval: 20 },
				],
			},
			{
				loop: true,
				pointsTo: ["NE"],
				frames: [
					{ filename: "DrillProjectile_NE_0.png", interval: 20 },
					{ filename: "DrillProjectile_NE_1.png", interval: 20 },
					{ filename: "DrillProjectile_NE_2.png", interval: 20 },
					{ filename: "DrillProjectile_NE_3.png", interval: 20 },
				],
			},
		],
	},
	{
		key: "Missile",
		allowTransform: true,
		animations: [
			{
				loop: true,
				pointsTo: ["N"],
				frames: [{ filename: "Missile_N.png", interval: 0 }],
			},
			{
				loop: true,
				pointsTo: ["NE"],
				frames: [{ filename: "Missile_NE.png", interval: 0 }],
			},
		],
	},
	{
		key: "HomingMissile",
		allowTransform: true,
		animations: [
			{
				loop: true,
				pointsTo: ["N"],
				frames: [{ filename: "Missile_N.png", interval: 0 }],
			},
			{
				loop: true,
				pointsTo: ["NE"],
				frames: [{ filename: "Missile_NE.png", interval: 0 }],
			},
		],
	},
	{
		key: "GasBomb",
		animations: [
			{
				loop: true,
				tags: { releasing: false },
				frames: [
					{ filename: "GasBomb.png", interval: 60, rotation: 0 },
					{ filename: "GasBomb.png", interval: 60, rotation: 1 },
					{ filename: "GasBomb.png", interval: 60, rotation: 2 },
					{ filename: "GasBomb.png", interval: 60, rotation: 3 },
				],
			},
			{
				loop: true,
				tags: { releasing: true },
				frames: [
					{ filename: "GasBomb.png", interval: 60, rotation: 0 },
				],
			},
			{
				loop: true,
				tags: { releasing: true },
				frames: [
					{ filename: "GasBomb.png", interval: 60, rotation: 0, horizontalFlip: true },
				],
			},
		],
	},
	{
		key: "AirBlastShot",
		allowTransform: true,
		animations: [
			{
				loop: true,
				pointsTo: ["E"],
				frames: [{ filename: "WhiteProjectile.png", interval: 0 }],
			},
		],
	},
];
